import { useContext, useEffect } from "react";
import { PageContext } from "../context/PageProvider";

/** What the tab is called before the host names an organisation, or where it names none. */
export const DefaultTitleBase = "Gantry";

/** "<organisation> - <title>", or the organisation alone for a page with no title. */
export function formatPageTitle(base: string, title?: string | null) {
  return title ? `${base} - ${title}` : base;
}

/**
 * Names the browser tab after the organisation and the page, as the legacy forms do.
 * Holds off while the host is still resolving the organisation, so the tab never shows
 * the default first and then changes. Outside a PageProvider it falls back to the
 * default rather than throwing, so a component rendered on its own still works.
 */
export function usePageTitle(title?: string | null, enabled = true) {
  const context = useContext(PageContext);
  const base = context?.organisationName || DefaultTitleBase;
  const resolved = context?.organisationResolved ?? true;

  useEffect(() => {
    if (!enabled || !resolved) {
      return;
    }

    document.title = formatPageTitle(base, title);
  }, [base, resolved, title, enabled]);
}
